import React, { Component } from "react";
import { dateFormaterSpecific } from "../../assets/Js/DateFormater";
import MessageCard from "./MessageCard.js";

export default class MessageSectionList extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { title, data } = this.props.sectionList;

    return (
      <>
        <li className="d-flex alignItem">
          <div className="line"></div>
          <div>
            <span>{dateFormaterSpecific(title)}</span>
          </div>
          <div className="line"></div>
        </li>
        {data.length &&
          data.map((messageInfo) => {
            return <MessageCard messageInfo={messageInfo} {...this.props} />;
          })}
      </>
    );
  }
}
